import { defineMessages } from 'react-intl';

const dataPortMessages = defineMessages({
    dataport: {
        id: 'dataport-point',
        defaultMessage: 'Data Port',
    },
    short: {
        id: 'dataport-point-short',
        defaultMessage: 'DP',
    },
});

export default dataPortMessages;
